import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

import type { CatalogServiceProductData } from 'src/services/catalog/types';
import { transformProductModelToProduct } from 'src/utils/catalogProductToProduct';
import type { PartnerProduct } from './types';

/**
 * One of a partner's products is one card's props. The mapping from catalog product
 * to OOUX product is shared with the product carousel, so both agree on what a
 * catalog product means; only the card-level presentation is decided here.
 */
export const transformProductModelToPartnerProduct = (
  product: CatalogServiceProductData,
  { currency, priority }: { currency: CurrencyCode; priority: boolean },
): PartnerProduct => ({
  isNew: product.isNew,
  priority,
  product: transformProductModelToProduct(product, { currency }),
  /* An offer, not a sale, and deliberately unlike the carousels, which promote
     every catalog discount as a sale event. A partner's reduced price is good news
     about that maker's product rather than part of a site-wide sale, so the card
     leads with the original price and colours the saving positively instead of
     flagging it with a sale tag in red.

     Constant, not `product.onSale`: the catalog sets that flag for reductions this
     block still presents as offers. Stated rather than left to the card's default
     so it reads as a decision, not an omission. No effect without a discount. */
  promoteAsSale: false,
});
